var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
var initialState = {
    hasCertificateHistory: false,
    isActiveRewardsTab: true
};
var initialContextValue = {
    state: initialState,
    dispatch: function () {
        throw new Error('Rewards page Context dispatch function not implemented');
    }
};
var RewardsPageContext = createContext(initialContextValue);
RewardsPageContext.displayName = 'RewardsPageContext';
export var useRewardsPageContext = function () {
    return useContext(RewardsPageContext);
};
var RewardsPageContextProvider = function (_a) {
    var children = _a.children;
    var _b = useState(initialState), rewardsPageState = _b[0], setRewardsPageState = _b[1];
    var dispatch = useCallback(function (newState) {
        setRewardsPageState(__assign(__assign({}, rewardsPageState), newState));
    }, [rewardsPageState]);
    var contextValue = useMemo(function () {
        return {
            state: rewardsPageState,
            dispatch: dispatch
        };
    }, [dispatch, rewardsPageState]);
    return (_jsx(RewardsPageContext.Provider, __assign({ value: contextValue }, { children: children })));
};
export default RewardsPageContextProvider;
